import { Component, OnInit, SkipSelf, ElementRef  } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { CopyService } from '../../services/copy.service';
import { RegistrationService } from '../../services/registration.service';
import { HotelService } from '../../services/hotel.service';
import { DateUtilityServiceService } from '../../services/date-utility-service.service';
import * as moment from 'moment-timezone';
import * as _ from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { HotelDetailsComponent } from 'src/app/reusable-components/hotel-details/hotel-details.component';
import { VariablesService } from '../../services/variables.service';


@Component({
  templateUrl: './hotel-booking.component.html'
})
export class HotelBookingComponent implements OnInit {
  enrollment;
  isSubmitting = false;
  hotelList;
  dateRange;
  groupDays;
  preextend;
  postextend;
  hotelStay;
  submitted;
  pickedHotel;
  soldOutHotels = [];
  charges = {
    Hotel: null,
  };
  CCerrors;
  cardError;
  payment;
  otherRequest;
  attendee;
  roommate;
  roommateName;
  roommateEmail;
  roommateArrival;
  roommateDeparture;
  arrivalDates;
  departureDates;
  beddingPreference;
  bedTypes;
  HoldSpecialRequests;
  isError = false;
  noHotel = false;
  isFormCompleted = false;
  isRegComplete: any;
  constructor(
    private navigationService: NavigationService,
    private copyService: CopyService,
    private registrationService: RegistrationService,
    private hotelService: HotelService,
    private dateService: DateUtilityServiceService,
    private variablesService: VariablesService,
    public dialog: MatDialog,
    private elRef: ElementRef,
  ) {

    this.enrollment = this.registrationService.getEnrollment({});
    this.attendee = this.registrationService.getAttendee({});
    this.hotelStay = this.registrationService.getHotel([]);
    if(this.hotelStay.length > 0){
      this.pickedHotel = this.hotelStay[0].Hotel
    }
    this.isRegComplete = this.registrationService.isRegistrationComplete();
    this.payment = this.registrationService.getPayment([]);
    this.beddingPreference = this.registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.BEDDING_PREFERENCE.ID,
      {}
    );
    this.roommateName = this.registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ROOMMATE_NAME.ID,
      {}
    );
    console.group(this.enrollment.HotelNeeded, this.roommateName)
    if (this.enrollment.HotelNeeded === true){
      this.roommate = 'yes';
    } 
    if (this.enrollment.HotelNeeded === false && this.roommateName.Value.length > 0){
      this.roommate = true;
    } else if (this.enrollment.HotelNeeded === false) {
      this.roommate = 'no'
    };
    console.log(this.roommate)
    this.roommateEmail = this.registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ROOMMATE_EMAIL.ID,
      {}
    );
    this.roommateArrival = this.registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ROOMMATE_ARRIVAL.ID,
      {}
    );
    this.roommateDeparture = this.registrationService.getVariable(
      this.attendee,
      this.variablesService.VARIABLE.ROOMMATE_DEPARTURE.ID,
      {}
    );
    this.bedTypes = [
      { value: 'King', display: "King" },
      { value: 'Two Double Beds', display: "Two Double Beds" },
      { value: "No Preference", display: "No Preference" }
    ]
    this.arrivalDates = [
      { value: 'Friday, October 25, 2024', display: 'Friday, October 25, 2024' },
      { value: 'Saturday, October 26, 2024', display: 'Saturday, October 26, 2024' },
      { value: 'Sunday, October 27, 2024', display: 'Sunday, October 27, 2024' },
      { value: 'Monday, October 28, 2024', display: 'Monday, October 28, 2024' },
      { value: 'Tuesday, October 29, 2024', display: 'Tuesday, October 29, 2024' }
    ];

    this.departureDates = [
      { value: 'Sunday, October 27, 2024', display: 'Sunday, October 27, 2024' },
      { value: 'Monday, October 28, 2024', display: 'Monday, October 28, 2024' },
      { value: 'Tuesday, October 29, 2024', display: 'Tuesday, October 29, 2024' },
      { value: 'Wednesday, October 30, 2024', display: 'Wednesday, October 30, 2024' },
      { value: 'Thursday, October 31, 2024', display: 'Thursday, October 31, 2024' },
      { value: 'Friday, November 1, 2024', display: 'Friday, November 1, 2024'}
    ];

    if (this.roommate === true) {
      this.enrollment.HotelNeeded = false;
    } else if (this.roommate === "yes") {
      this.enrollment.HotelNeeded = true;
    } else if (this.roommate === "no") {
      this.enrollment.HotelNeeded = false;
    }

    this.hotelService.getHotelList().then(list => {
      this.hotelList = list;
      if (this.hotelList) {
        this.dateRange = this.dateService.calculateDateRange(this.hotelList.firstNight, this.hotelList.lastNight);
        this.preextend = this.dateService.dateDiff(moment.utc(this.hotelList.firstNight, "YYYY-MM-DD HH:mm:ss.SSS+Z").tz("America/Chicago"), moment.utc(this.hotelList.groupStartDate, "YYYY-MM-DD HH:mm:ss.SSS+Z").tz("America/Chicago"));

        this.groupDays = dateService.dateDiff(moment.utc(this.hotelList.groupStartDate, "YYYY-MM-DD HH:mm:ss.SSS+Z").tz("America/Chicago"), moment.utc(this.hotelList.groupEndDate, "YYYY-MM-DD HH:mm:ss.SSS+Z").tz("America/Chicago"));
        this.postextend = dateService.dateDiff(moment.utc(this.hotelList.groupEndDate, "YYYY-MM-DD HH:mm:ss.SSS+Z").tz("America/Chicago"), moment.utc(this.hotelList.lastNight, "YYYY-MM-DD HH:mm:ss.SSS+Z").tz("America/Chicago"));
        this.hotelList.roomTypeList = _.orderBy(this.hotelList.roomTypeList, ['displaySeqNo'], ['asc']);

        if (!this.hotelStay.length) {
          //look for booked stays.

          this.hotelList.roomTypeList = _.orderBy(this.hotelList.roomTypeList, ['displaySeqNo'], ['asc']);
          this.hotelList.roomTypeList.forEach((roomtype) => {
            var groupid = roomtype.webHotelGroupID;
            var pending = _.filter(roomtype.roomNightsListWithRate, { availabilityCode: 2 });
            var reserved = _.filter(roomtype.roomNightsListWithRate, { availabilityCode: 3 });
            reserved = _.union(pending, reserved);
            reserved.forEach((res) => {
              this.hotelStay.push({ Date: res.blockDate, Hotel: groupid });
            });
          });
        }

        if (this.isRegComplete) {
          if (this.enrollment.WebHotelBooking.length) {
            //look for booked stays.
            this.hotelList.roomTypeList.forEach((roomtype) => {
              var groupid = roomtype.webHotelGroupID;
              var pending = _.filter(roomtype.roomNightsListWithRate, { availabilityCode: 2 });
              var reserved = _.filter(roomtype.roomNightsListWithRate, { availabilityCode: 3 });
              reserved = _.union(pending, reserved);
              reserved.forEach((res) => {
                this.hotelStay.push({ Date: res.blockDate, Hotel: groupid });
              });
            });
          }

          let filter = [];
          this.hotelStay.forEach((stay) => {
            if (stay.Date.indexOf("0000000") < 0) {
              filter.push(stay);
            }
          });
          filter = _.uniqBy(filter, 'Date');
          this.hotelStay = filter;
          this.enrollment.WebHotelBooking = filter;
        }
        this.hotelList.roomTypeList.forEach(hotelNight => {
          hotelNight.roomNightsListWithRate.forEach(hotel => {
            if(hotel.availabilityCode === 0) {
              if (!this.outsideGroupDates(hotel.blockDate)){
                this.soldOutHotels.push(hotelNight.webHotelGroupID)
              }
            }
            
          })
        })
      }



    });

  }
  ngOnInit(): void {
  }
  noHotelRadios = [
    { display: "Staying at local residence", value: "Staying at local residence" },
    { display: "Sharing a room reserved by someone else", value: "Sharing a room reserved by someone else" },
    { display: "Arranged my own accommodations", value: "Arranged my own accommodations" },
    { display: "Other", value: "Other"}
  ];
  isHotelAvailableOnDate(hotellist, date) {
    if(this.attendee.PAXTypeNo == 10){
      let hotel = this.findDate(hotellist, date);
      if (hotel) {
        if (hotel.availabilityCode === 1 || hotel.availabilityCode === 2 || hotel.availabilityCode === 3) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return !this.soldOutHotels.includes(hotellist.webHotelGroupID)
    }
  };
  updateDate() {
    this.departureDates = [
      { value: 'Sunday, October 27, 2024', display: 'Sunday, October 27, 2024' },
      { value: 'Monday, October 28, 2024', display: 'Monday, October 28, 2024' },
      { value: 'Tuesday, October 29, 2024', display: 'Tuesday, October 29, 2024' },
      { value: 'Wednesday, October 30, 2024', display: 'Wednesday, October 30, 2024' },
      { value: 'Thursday, October 31, 2024', display: 'Thursday, October 31, 2024' },
      { value: 'Friday, November 1, 2024', display: 'Friday, November 1, 2024'}
    ];
    if (this.roommateArrival.Value === 'Sunday, October 27, 2024') {
      this.departureDates = [
        { value: 'Monday, October 28, 2024', display: 'Monday, October 28, 2024' },
        { value: 'Tuesday, October 29, 2024', display: 'Tuesday, October 29, 2024' },
        { value: 'Wednesday, October 30, 2024', display: 'Wednesday, October 30, 2024' },
        { value: 'Thursday, October 31, 2024', display: 'Thursday, October 31, 2024' },
        { value: 'Friday, November 1, 2024', display: 'Friday, November 1, 2024'}
      ];
    } else if (this.roommateArrival.Value === 'Monday, October 28, 2024') {
      this.departureDates = [
        { value: 'Tuesday, October 29, 2024', display: 'Tuesday, October 29, 2024' },
        { value: 'Wednesday, October 30, 2024', display: 'Wednesday, October 30, 2024' },
        { value: 'Thursday, October 31, 2024', display: 'Thursday, October 31, 2024' },
        { value: 'Friday, November 1, 2024', display: 'Friday, November 1, 2024'}
      ];
    } else if (this.roommateArrival.Value === 'Tuesday, October 29, 2024') {
      this.departureDates = [
        { value: 'Wednesday, October 30, 2024', display: 'Wednesday, October 30, 2024' },
        { value: 'Thursday, October 31, 2024', display: 'Thursday, October 31, 2024' },
        { value: 'Friday, November 1, 2024', display: 'Friday, November 1, 2024'}
      ];
    }
  }
  updateArrDate() {
    this.arrivalDates = [
      { value: 'Friday, October 25, 2024', display: 'Friday, October 25, 2024' },
      { value: 'Saturday, October 26, 2024', display: 'Saturday, October 26, 2024' },
      { value: 'Sunday, October 27, 2024', display: 'Sunday, October 27, 2024' },
      { value: 'Monday, October 28, 2024', display: 'Monday, October 28, 2024' },
      { value: 'Tuesday, October 29, 2024', display: 'Tuesday, October 29, 2024' }
    ];
    if(this.roommateDeparture.Value === 'Sunday, October 27, 2024'){
      this.arrivalDates = [
        { value: 'Friday, October 25, 2024', display: 'Friday, October 25, 2024' },
        { value: 'Saturday, October 26, 2024', display: 'Saturday, October 26, 2024' }
      ]
    } else if (this.roommateDeparture.Value === 'Monday, October 28, 2024') {
      this.arrivalDates = [
        { value: 'Friday, October 25, 2024', display: 'Friday, October 25, 2024' },
        { value: 'Saturday, October 26, 2024', display: 'Saturday, October 26, 2024' },
        { value: 'Sunday, October 27, 2024', display: 'Sunday, October 27, 2024' },
      ];
    } else if (this.roommateDeparture.Value === 'Tuesday, October 29, 2024'){
      this.arrivalDates = [
        { value: 'Friday, October 25, 2024', display: 'Friday, October 25, 2024' },
        { value: 'Saturday, October 26, 2024', display: 'Saturday, October 26, 2024' },
        { value: 'Sunday, October 27, 2024', display: 'Sunday, October 27, 2024' },
        { value: 'Monday, October 28, 2024', display: 'Monday, October 28, 2024' }
      ];
    }
  }
  unchecked(){
    if(this.hotelStay.length === 0){
      this.pickedHotel = undefined;
    }
  }

  addNight(date, hotel) {
    this.noHotel = false;
    this.pickedHotel = hotel;
    var tobe = { Date: date, Hotel: hotel };
    var search = _.filter(this.hotelStay, { Date: date });
    if (search.length) {
      _.remove(this.hotelStay, search[0]);
      if (search[0].Hotel !== hotel) {
        this.hotelStay.push(tobe);
      }
    } else {
      this.hotelStay.push(tobe);
    }

    var isExtension = false;
    this.hotelStay.forEach((stay) => {

      var date = this.dateService.createMoment(stay.Date).toDate();

      if (this.outsideGroupDates(date)) {
        isExtension = true;
      }
    });
    if (isExtension) {
      this.enrollment.$mtcExtension = true;
    } else {
      this.enrollment.$mtcExtension = undefined;
    }
  };

  validateCards() {
    this.CCerrors = [];
    this.cardError = false;
    console.log(this.payment);
    if(this.roommate === true || this.roommate === 'yes'){
      let card = this.registrationService.getCreditCard(this.registrationService.getPayment([]), "Hotel", undefined);
      if(!card || !card.ReferenceKey){
        this.cardError = true;
        this.CCerrors.push("Hotel Guarantee Card is required");
      }}
    
    return this.cardError;
  }

  clearRequests() {
    console.log(this.enrollment.HotelNeeded, 'hotel needed')
    if (this.roommate === true) {
      this.enrollment.HotelNeeded = false;
    } else if (this.roommate === "yes") {
      this.enrollment.HotelNeeded = true;
    } else if (this.roommate === "no") {
      this.enrollment.HotelNeeded = false;
    }
    if (this.enrollment.HotelNeeded === true) {
      if (this.enrollment.HotelSpecialRequests === "Staying at local residence" || this.enrollment.HotelSpecialRequests === "Sharing a room reserved by someone else"
        || this.enrollment.HotelSpecialRequests === "Arranged my own accommodations" || this.enrollment.HotelSpecialRequests === "I will add my hotel later" || this.enrollment.HotelSpecialRequests.includes("Other")) {
        this.HoldSpecialRequests = this.enrollment.HotelSpecialRequests;
        this.enrollment.HotelSpecialRequests = "";
      }
    } else if (this.HoldSpecialRequests) {
      this.enrollment.HotelSpecialRequests = this.HoldSpecialRequests;
    }
  }

  outsideGroupDates(date) {
    console.log(date + " < " + this.hotelList.groupStartDate);
    return date < moment.utc(this.hotelList.groupStartDate, "YYYY-MM-DD HH:mm:ss.SSS+Z").tz("America/Chicago").toDate()
      || date > moment.utc(this.hotelList.groupEndDate, "YYYY-MM-DD HH:mm:ss.SSS+Z").tz("America/Chicago").toDate();
  };

  findDate(hotelList, searchDate) {
    let newDate = moment.utc(searchDate, "YYYY-MM-DD HH:mm:ss.SSS+Z").toDate();
    var match;
    if (typeof newDate !== "undefined") {
      match = _.find(hotelList.roomNightsListWithRate, (night) => {
        var blockDate = moment.utc(night.blockDate, "YYYY-MM-DD HH:mm:ss.SSS+Z").tz("America/Chicago").toDate();

        return newDate.getDate() === blockDate.getDate() && newDate.getMonth() === blockDate.getMonth();
      });
    }
    return match;
  };

  declineRadios = [
    {
      value: 'Business Conflict',
      display: this.copyService.getCopyByKey(
        'copy.label.INVITATION.declineReason1'
      )
    },
    {
      value: 'Personal Conflict',
      display: this.copyService.getCopyByKey(
        'copy.label.INVITATION.declineReason2'
      )
    },
    {
      value: 'other',
      display: this.copyService.getCopyByKey(
        'copy.label.INVITATION.declineReason3'
      )
    }
  ];
  getNonContiguousHotels() {
    var hotels = [];
    if (typeof this.hotelList !== "undefined") {
      hotels = this.hotelService.getNonContiguousHotelNights(this.hotelList.roomTypeList, this.hotelStay);
    }
    return hotels;
  };
  isChecked(date, hotel) {
    //console.log("in isChecked");
    var search = _.filter(this.hotelStay, { Date: date });
    if (search.length) {
      if (search[0].Hotel === hotel) {
        //console.log("return true");
        return true;
      }
    }
    return false;
  };
  getColor(night) {
    if (night.availabilityCode === 0) {
      return '#fcb1ae'
    }
    if (night.isBookedAsPending === true) {
      return '#f8fab1';
    }
    if (night.isBookedAsPending === false) {
      return '#bcffb5'
    }
    return 'white';
  }

  private scrollInvalidBruh() {
    const invalidBruh: HTMLElement = this.elRef.nativeElement.querySelector(
      ".bacon"
    );
    let bruh = invalidBruh.getBoundingClientRect();

    console.log(invalidBruh);

    window.scroll({top: bruh.top + window.scrollY, left: 0, behavior: "smooth"});
  }


  forward(form) {
    console.log(this.enrollment.HotelNeeded === true)
    this.isFormCompleted = true;
    if (this.enrollment.HotelNeeded !== undefined) {
        if (this.enrollment.HotelNeeded) {
          this.roommateArrival.Value = '';
          this.roommateDeparture.Value = '';
        // User must have selected hotels on contiguous dates
        if (this.hotelStay.length > 0 && this.hotelService.getNonContiguousHotelNights(this.hotelList.roomTypeList, this.hotelStay).length <= 0) {
          if(form.valid && !this.validateCards()){
          this.isSubmitting = true;

          this.navigationService.forward();
        }
        } else {
          this.noHotel = true;
          this.scrollInvalidBruh();
          this.isError = true;
          this.isSubmitting = false;
        }
      } else {
        if(form.valid && !this.validateCards()){
          this.beddingPreference.Value = ''
          if ( this.roommate === 'no' ) {
            this.roommateEmail.Value = '';
            this.roommateArrival.Value = '';
            this.roommateDeparture.Value = '';
            this.roommateName.Value = '';
          }
          this.enrollment.WebHotelBooking = [];
          this.isSubmitting = true;
          this.navigationService.forward();
        }
      }
    } else {

      this.isSubmitting = false;
    }
    if(this.otherRequest && this.enrollment.HotelSpecialRequests == "Other"){
      this.enrollment.HotelSpecialRequests = "Other: " + this.otherRequest;
    }
  }

  back() {
    this.navigationService.back();
  }

  showModal(hotel) {
    // if (!hotel.displaySection) {
    // new ModalService("Hotel" + hotel.webHotelGroupDesc.replace(/[\s]/g, ""), "Hotel Details");
    let dialogRef = this.dialog.open(HotelDetailsComponent, { panelClass: 'hotel-container', data: hotel });
    hotel.displaySection = false;
  }
}
